import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

export default function LanguageSwitcher() {
    const { i18n } = useTranslation();
    const current = i18n.language?.startsWith("it") ? "it" : "en";

    const switchTo = (lang) => {
        i18n.changeLanguage(lang);
        try {
            localStorage.setItem("portal_lang", lang);
        } catch (err) {
            console.warn("Could not persist language preference:", err);
        }
    };

    return (
        <div
            data-testid="language-switcher"
            className="inline-flex items-center border border-white/15 divide-x divide-white/15"
        >
            <span className="px-2 py-2 text-slate-500">
                <Globe className="w-3 h-3" />
            </span>
            <button
                data-testid="lang-en"
                onClick={() => switchTo("en")}
                className={`px-3 py-2 text-[10px] font-mono uppercase tracking-widest transition-colors ${
                    current === "en" ? "text-white bg-white/5" : "text-slate-500 hover:text-white"
                }`}
            >
                EN
            </button>
            <button
                data-testid="lang-it"
                onClick={() => switchTo("it")}
                className={`px-3 py-2 text-[10px] font-mono uppercase tracking-widest transition-colors ${
                    current === "it" ? "text-white bg-white/5" : "text-slate-500 hover:text-white"
                }`}
            >
                IT
            </button>
        </div>
    );
}
